import ActivityReducer from '../slices/activity';
import AppReducer from '../slices';
import AutomationReducer from '../slices/automation';
import BookingReducer from '../slices/booking';
import CalendarFormBuilderReducer from '../slices/calendar_form_builder';
import CalendarReducer from '../slices/calendar';
import ChartReducer from '../slices/chart';
import ClientReducer from '../slices/client';
import { combineReducers } from '@reduxjs/toolkit';
import ContactReducer from '../slices/contact';
import CustomerReducer from '../slices/customer';
import DealReducer from '../slices/deal';
import DomainReducer from '../slices/domain';
import EmailReducer from '../slices/email';
import ErrorReducer from '../slices/error';
import FileReducer from '../slices/file';
import FolderReducer from '../slices/folder';
import FormReducer from '../slices/form';
import IntegrationReducer from '../slices/integration';
import LeadReducer from '../slices/leads';
import MessageBoardReducer from '../slices/messageboard';
import NoteReducer from '../slices/note';
import NotificationReducer from '../slices/notification';
import PipelineReducer from '../slices/pipeline';
import ProductReducer from '../slices/product';
import ProspectReducer from '../slices/prospect';
import ReminderReducer from '../slices/reminder';
import ReviewReducer from '../slices/review';
import SMSReducer from '../slices/sms';
import StageReducer from '../slices/stage';
import SubscriptionReducer from '../slices/subscription';
import TaskReducer from '../slices/task';
import TeamReducer from '../slices/team';
import WaterCoolerReducer from '../slices/watercooler';
import WorkflowReducer from '../slices/workflow';

const rootReducer = combineReducers({
    activity: ActivityReducer,
    app: AppReducer,
    automation: AutomationReducer,
    booking: BookingReducer,
    calendar: CalendarReducer,
    calendarformbuilder: CalendarFormBuilderReducer,
    chart: ChartReducer,
    client: ClientReducer,
    contact: ContactReducer,
    customer: CustomerReducer,
    deal: DealReducer,
    domain: DomainReducer,
    email: EmailReducer,
    error: ErrorReducer,
    file: FileReducer,
    folder: FolderReducer,
    form: FormReducer,
    integration: IntegrationReducer,
    lead: LeadReducer,
    messageboard: MessageBoardReducer,
    notification: NotificationReducer,
    note: NoteReducer,
    pipeline: PipelineReducer,
    product: ProductReducer,
    prospect: ProspectReducer,
    reminder: ReminderReducer,
    review: ReviewReducer,
    sms: SMSReducer,
    stage: StageReducer,
    subscription: SubscriptionReducer,
    task: TaskReducer,
    team: TeamReducer,
    watercooler: WaterCoolerReducer,
    workflow: WorkflowReducer
});
export type RootStateType = ReturnType<typeof rootReducer>;

export default rootReducer;